/**
 * 简体中文
 */
export default {
  header: {
    lang: '简繁切换',
    app: 'APP下载',
    about: '关于我们',
    instruction: '使用指南',
    tip_windows:
      '为了您的使用体验，推荐使用360极速浏览器或者QQ浏览器的极速模式访问本系统。',
    tip_mac: '为了您的使用体验，推荐使用Safari浏览器访问本系统。',
    browser360: '360极速浏览器',
    browserqq: '下载QQ浏览器'
  },
  footer: {
    youth: '青少年安全上网',
    declare: '免责声明',
    private: '隐私政策',
    copyright: ' All Rights Reserved.',
    icp: '苏ICP备14027754号-4',
    browser360: '下载360极速浏览器',
    browserqq: '下载QQ浏览器',
    djg: '驰声大学听说教学平台现已接入国家数字教育资源平台，欢迎监督。',
    pj: '评价',
    jb: '举报'
  },
  dialog: {
    iknow: '我知道了',
    sso: {
      title: '退出提示',
      textL: '你的账号于',
      textR: '在另一台电脑上登录，已被迫退出。',
      tip: '如非本人操作，则密码可能已泄露，请尽快修改密码。',
      btnL: '我知道了',
      btnR: '重新登录'
    },
    newPractice: {
      titleL: '嘿，你有新的',
      titleR: '啦~',
      textL: '剩',
      textR: '次答题机会',
      noLimit: '不限答题次数',
      btnL: '知道了',
      btnR: '去练习'
    },
    continue: {
      text: '上次答题还未完成，是否继续测评？',
      btnL: '继续测评',
      btnR: '重新测评'
    },
    payment: {
      title: '订单确认',
      content: '购买内容',
      cost: '订单费用',
      costR: '元',
      type: '支付方式',
      cancel: '取消',
      submit: '立即支付',
      tipTitle: '温馨提示',
      tipText1: '请在新打开的页面完成指支付，',
      tipText2: '支付完成前，请不要关闭次窗口',
      tipText3: '。支付完成后请根据您的情况点击下面内容：',
      tipBtn: '已完成支付',
      failText: '未完成支付，请重新支付',
      failBtn: '好的',
      successText: '购买成功',
      successBtn: '确认'
    }
  },
  sidebar: {
    feedback: '在线反馈',
    onlineService: '在线咨询',
    app: '扫码下载',
    help: '帮助中心',
    top: '返回顶部',
    appDialog: {
      tips: '学生端扫码下载'
    },
    fbDialog: {
      title: '在线反馈',
      contact: '联系方式',
      contactPH: 'QQ\\E-mail\\手机号',
      suggest: '问题或建议',
      submit: '提交',
      submitComplete: '提交完成！',
      thank: '你的信息反馈我们已经收到，我们会尽快给你答复，谢谢~',
      continue: '继续反馈'
    },
    dtDialog: {
      tips: '系统检测到你更换了电脑或浏览器，需要重新检测电脑和网络。',
      btnText: '立即检测'
    }
  },
  select: {
    plz: '请选择'
  },
  detection: {
    step1: {
      title: '设备检测说明',
      text1: '为了保证你的正常答题，需要进行设备检测，',
      text2: '请佩戴好耳机。',
      btn: '开始检测',
      tip: '注：为保证良好的学习体验，建议配备专业的指向型麦克风，',
      linktext: '购买链接'
    },
    step2: {
      text: '现在开始耳机检测，请听音频...',
      skip: '跳过 ▶'
    },
    step3: {
      text: '能否听清刚才的音频？',
      btnL: '不能',
      btnR: '能'
    },
    step4: {
      text: '请大声朗读：',
      content: 'One Two Three'
    },
    step5: {
      title: '通过检测',
      btn: '返回'
    },
    browserErr: {
      title: '不支持当前浏览器环境',
      text1: '若当前使用的是360极速或者QQ浏览器，请切换到极速模式',
      text2: '若非360浏览器，请下载360极速浏览器。',
      text22: '若使用其他浏览器，请下载360极速或者QQ浏览器。',
      btnL: '下载360极速浏览器',
      btnR: '下载QQ浏览器'
    },
    micErr: {
      title: '麦克风检测',
      text1: '没有检测到耳机和麦克风',
      text2: '请重新拔插耳机后',
      redText: '重启浏览器或客户端'
    },
    playErr: {
      title1: '如果你不在考场',
      text1: '请检查你的耳机',
      title2: '如果你正在考场',
      text2: '请举手示意，请求协助！',
      btn: '重试'
    },
    recordErr: {
      title: '检测失败',
      text1: '为保证评分效果，请按照指导，大声，准确朗读',
      text2: '非考场考生请检查麦克风！',
      text3: '考生请举手示意教师',
      btn: '重试'
    },
    volumeErr: {
      title: '录音音量太小！',
      text1: '为保证评分效果，请按照指导，大声，准确朗读',
      text2: '非考场考生请检查麦克风！',
      text3: '考生请举手示意教师',
      btn: '重试'
    },
    netErr: {
      title: '网络异常，请重试！',
      text1: '*请确认网络连接正常，能正常访问网络',
      text2: '非考场考生请检查网络！',
      text3: '考生请举手示意教师',
      btn: '重试'
    },
    audioMis: '未获取到音频，请点击重试',
    start: {
      text1: '为了顺利完成练习，',
      text2: '你需要先进行设备检测。',
      btn: '马上开始'
    }
  },
  Login: {
    loginBody: {
      identity: ['学生', '教师', '家长', '教研'],
      login: '登 录',
      rememberPass: '记住密码',
      forgetPass: '忘记密码',
      downloadQR: '扫码下载APP',
      register: '立即注册',
      downloadByPhone: '手机扫码下载',
      studentMobile: '学生端APP下载',
      teacherMobile: '教师端APP下载'
    },
    findPwd: {
      title: '找回密码',
      step: ['确认账号', '修改密码', '完成'],
      phone: '手机号',
      phonePH: '请输入手机号',
      verify: '验证码',
      verifyPH: '请输入手机验证码',
      verifyBtn: '获取验证码',
      newPwd: '设置新密码',
      newPwdPH: '请输入新密码',
      newPwd2: '再次输入新密码',
      newPwdPH2: '请输入新密码',
      next: '下一步',
      relogin: '重新登陆',
      success: '密码修改成功',
      tips: '温馨提示：系统仅支持已绑定手机号码的账号，找回密码',
      error: {
        phoneError: '请输入11位手机号码',
        verifyEmpty: '验证码不能为空',
        pwdInconsistent: '密码设置不一致',
        pwdEmpty: '密码不能为空'
      }
    },
    register: {
      title: '注册学生账号',
      phoneNumber: '手机号：',
      captcha: '图形验证码：',
      captchaPh: '请输入图形验证码',
      changeOne: '换一个',
      phoneCode: '手机验证码：',
      phoneCodePh: '请输入手机验证码',
      getCode: '获取验证码',
      password: '密码：',
      passwordPh: '请输入密码',
      certifyPassword: '确认密码：',
      newPasswordPh: '请再次输入密码',
      accept: '我已阅读并接受',
      agreement: '《用户服务协议》',
      rMsg: '注册',
      haveOne: '已有账号?',
      rightNow: '立即登录',
      error: {
        phoneError: '请输入11位手机号码',
        phoneCodeError: '手机验证码不正确',
        captchaError: '请输入4位图形校验码',
        pwdEmpty: '密码不能为空',
        pwdInconsistent: '两次密码输入不一致'
      }
    },
    perfect: {
      title: '注册成功，请完善个人信息',
      name: '姓名：',
      namePh: '请输入学生姓名',
      sex: '性别：',
      sexDefault: '男',
      sexOther: '女',
      idNumber: '身份证：',
      idNumberPh: '请正确填写15位或18位身份证号码',
      area: '所在地区：',
      school: '所在学校：',
      other: '其他',
      schoolMsg: '若下拉菜单中没有找到你的学校，请在“其他”框输入学校名称',
      schoolPh: '请输入学校名称',
      categroy: '所在年级：',
      class: '所在班级：',
      teacher: '辅导教师：',
      teacherPh: '请输入辅导教师名称',
      teacherPhone: '教师电话：',
      teacherPhonePh: '请输入辅导教师电话',
      attention: '必填信息(*)提交后不可更改，请谨慎操作！',
      save: '保存',
      error: {
        stuNameErrMsg: '学生名字不能为空',
        idNumberErrMsg: '身份证格式不正确',
        teaNameErrMsg: '教师姓名不能为空',
        teaNumberErrMsg: '辅导教师号码格式不正确',
        schoolErrMsg: '请选择学校',
        categoryErrMsg: '请选择所在年级',
        classErrMsg: '请选择所在班级',
        areaErrMsg: '请选择省市区'
      }
    }
  },
  Stu: {
    nav: {
      index: '首页',
      sync: '教材学习',
      syncwork: '听说练习',
      record: '成长记录',
      bible: '听说宝典',
      msg: '消息中心',
      info: '个人中心',
      logout: '退出登录',
      TTrain: '专题培训',
      TTrainDetail: '课程详情',
      Ttopics: '基础训练',
      Ttsks: '综合训练',
      Trecord: '结业评估',
      myBook: '我的图书'
    },
    backlogList: {
      total: '待完成的练习',
      workcount: '个',
      over: '离结束剩',
      day: '天',
      hour: '小时',
      min: '分',
      nonwork: '暂无教师布置的练习',
      recommend: '试一试推荐的学习内容吧',
      btn: {
        viewComplete: '查看已完成练习',
        startwork: '开始练习',
        viewDetail: '查看详情',
        viewMore: '查看更多',
        practice: '开始练习',
        redo: '重做'
      }
    },
    backlogListJF: {
      empty: '暂无练习或考试任务'
    },
    nine: {
      Aggregate: '错题本',
      Collection: '收藏本',
      Phonetics: '音标学习',
      TSKS: '听说考试',
      Special: '专项训练',
      Topics: '话题项目',
      STS: '视听说',
      Dialogue: '情景对话',
      Composition: '智能作文'
    },
    StuIndex: {
      trends: '完成了',
      promoteCong: '恭喜顺利晋级',
      promoteBtn: '查看详细',
      promoteGradeCongL: '恭喜',
      promoteGradeCongR: '顺利进入',
      promoteGradeBtn1: '去修改',
      promoteGradeBtn2: '确认',
      promoteGradeBtn3: '知道了',
      promoteGradeTip: '确认后，年级信息不可修改，请谨慎操作',
      kyzx: {
        title: '口语之星',
        showtipMsg: '本周班级口语练习都在70分以上且排名前三的同学可以上榜哦~'
      },
      bjsy: {
        title: '班级好声音',
        showtipMsg: '上周班级优质好声音',
        emptyMsg1: '汇集班级英语好声音',
        emptyMsg2: '展示英语口语风采',
        change: '换一批'
      },
      bjdt: {
        title: '班级动态',
        emptyMsg1: '了解班级学习动态',
        emptyMsg2: '一起努力提高英语成绩',
        more: '查看更多'
      },
      tips: {
        title: '机房小贴士',
        text1:
          '欢迎使用驰声大学听说教学平台——机房版。该版本专为学生在机房练习考试场景设置，基本特征如下：',
        text2: '老师布置的学校机房场景任务，学生只能通过机房版进行完成。',
        text3: '学生可直接使用自己的平台账号登录，完成指定内容的练习或考试。',
        text4: '学生在机房完成的任务，也可以通过登录个人设备查看练习记录报告。'
      }
    },
    StuExamDetail: {
      // 测评详情
      join: '人参与',
      rBtnFree: '查看报告',
      rBtnUnbuy: '分数报告',
      rBtnBuy: '诊断报告',
      subTimeL: '剩 ',
      subTimeR: '次机会',
      noSubTime: '测评机会已用完'
    },
    lowScore: {
      // 错题本&收藏本
      type: '类型',
      count: '共',
      isCorrect: '已订正',
      topic: '道试题',
      empty: '学霸都这样！一个错题都木有',
      emptyCollection: '你一个题都还没收藏',
      ability: '考察能力',
      knowledge: '知识点',
      difficulty: '难度',
      expand: '收起信息',
      detail: '详情及解析',
      practice: '练习',
      correct: '订正'
    },
    examPaper: {
      contain: '含',
      paper: '份试卷',
      participates: '人参与',
      btn: {
        practice: '测评',
        report: '报告'
      }
    },
    StuPhonetics: {
      backToIndex: '返回首页',
      pdHeader: '的发音学习',
      pdTitle1: '发音详解',
      pdTitle2: '关联的字母及组合',
      pdScoreL: '上次练习',
      pdScoreR: '分',
      pdBtn: '挑战一下',
      pdPrev: '上一个',
      pdNext: '下一个'
    },
    StuSTS: {
      btnText: '练习'
    },
    StuTSKS: {
      type: '类型',
      tips: {
        good: '优',
        normal: '良',
        bad: '差',
        undo: '未做'
      },
      btn: {
        practice: '测评',
        report: '报告'
      },
      avatar: {
        nobody: '暂无同学练习',
        other: '等',
        text: '位同学练过'
      }
    },
    StuComposition: {
      countL: '共',
      countR: '道题',
      ability: '考察能力',
      knowledge: '知识点',
      difficulty: '难度',
      slideUp: '收起信息',
      slideDown: '详情',
      btnText: '练习'
    },
    StuSync: {
      notValid: '该教材已删除',
      preview: {
        head: '练习内容预览'
      },
      books: {
        head: '设置教材'
      },
      noBook: '哎呀，还没有可用的教材呢',
      noContent: '该课本没有内容'
    },
    StuMsgCenter: {
      readAll: '全部设为已读',
      allNotices: '全部消息',
      prev: '上一个',
      next: '下一个',
      empty: '还没有收到消息哦~'
    },
    StuSpecial: {
      empty: '暂无练习'
    },
    TIndex: {
      detail: '研训详情'
    },
    StuBook: {
      empty: '暂无内容',
      btn: {
        bind: '+ 绑定图书'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/script/i18n/zh.js